// extracted by mini-css-extract-plugin
export default {"wrapper":"EditProjectsForm_wrapper__jtnDZ","submitWrapper":"EditProjectsForm_submitWrapper__3f3Cz"};